import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionComponent } from './question/question.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UserStatsWrapperComponent } from './user-stats-wrapper/user-stats-wrapper.component';
import { HomeButtonComponent } from './home-button/home-button.component';
import { CountdownComponent } from './countdown/countdown.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { ResumeGameCtaComponent } from './resume-game-cta/resume-game-cta.component';
import { EnergyPointsComponent } from './energy-points/energy-points.component';
import { ProgressRingComponent } from './progress-ring/progress-ring.component';
import { RoundedButtonComponent } from './rounded-button/rounded-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { QuestionBannerComponent } from './question-banner/question-banner.component';
import { HttpClientModule } from '@angular/common/http';
import { SvgLoaderComponent } from './svg-loader/svg-loader.component';
import { GamesListItemComponent } from './games-list-item/games-list-item.component';
import { ProfilePicsComponent } from './profile-pics/profile-pics.component';
import { CloseButtonComponent } from './close-button/close-button.component';
import { LanguageOptionsComponent } from './language-options/language-options.component';
import { RouterModule } from '@angular/router';
import { QuestionOptionsModule } from '../question-options/question-options.module';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { GarminGuideComponent } from './garmin-guide/garmin-guide.component';
import { BrowserModule } from '@angular/platform-browser';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

@NgModule({
  declarations: [
    ProgressBarComponent,
    UserStatsWrapperComponent,
    HomeButtonComponent,
    CountdownComponent,
    MenuItemComponent,
    ResumeGameCtaComponent,
    EnergyPointsComponent,
    ProgressRingComponent,
    RoundedButtonComponent,
    ToolbarComponent,
    QuestionBannerComponent,
    SvgLoaderComponent,
    GamesListItemComponent,
    ProfilePicsComponent,
    CloseButtonComponent,
    LanguageOptionsComponent,
    GarminGuideComponent,
    TermsAndConditionsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    TranslateModule.forChild({ extend: true }),
    RouterModule,
    NgImageFullscreenViewModule,
  ],
  exports: [
    ProfilePicsComponent,
    ProgressBarComponent,
    UserStatsWrapperComponent,
    HomeButtonComponent,
    CountdownComponent,
    MenuItemComponent,
    ResumeGameCtaComponent,
    EnergyPointsComponent,
    ProgressRingComponent,
    RoundedButtonComponent,
    ToolbarComponent,
    GamesListItemComponent,
    QuestionBannerComponent,
    SvgLoaderComponent,
    CloseButtonComponent,
    LanguageOptionsComponent,
    GarminGuideComponent,
    TermsAndConditionsComponent,
  ],
})
export class ComponentsModule {}
